import { z } from "zod";
export const CommunityAuthor = z.object({
    userId: z.string().uuid(),
    displayName: z.string(),
    initials: z.string(),
    teamLabel: z.string().nullable(),
    avatarUrl: z.string().nullable(),
    avatarColor: z.string().nullable(),
});
export const CommunityKudosRecipient = CommunityAuthor.extend({
    hiddenFromPublicAt: z.string().nullable(),
});
export const CommunityTeammate = CommunityAuthor.extend({
    searchableText: z.string(),
});
export const ListCommunityTeammatesQuery = z.object({
    q: z.string().optional(),
    limit: z.string().optional(),
});
export const ListCommunityTeammatesResponse = z.object({
    teammates: z.array(CommunityTeammate),
});
//# sourceMappingURL=author.js.map